import { useEffect } from 'react';
import { commonService } from '../../../Common/CommonService';
import { Product } from '../../../Common/CommonModel';

export const useProducts = (
  setLoading: (loading: boolean) => void,
  setProducts: (products: Product[]) => void,
  setError: (error: string) => void,
) => {
  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    setLoading(true);
    try {
      const products = await commonService.getProducts();
      setProducts(products.Items);
    } catch (error) {
      console.error('Error loading products:', error);
      setError('Error loading products. Please try again.');
    } finally {
      setLoading(false);
    }
  };
};
